import api from '../../api'

const getDefaultState = () => {
  return {
    all: []
  }
}

const state = getDefaultState()

const getters = {
  getPoints: (state) => state.all
}

const actions = {
  fetchPoints ({ commit }, word) {
    return new Promise((resolve) => {
      const params = {
        name: word
      }
      api.getPoint(params)
        .then(data => {
          commit('setPoint', data)
          resolve()
        })
    })
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setPoint(state, data) {
    Object.assign(state.all, data)
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
